<div class="roi-popup-overlay" [class.active]="demoPopupVisible">
    <div class="roi-popup" style="max-width: 900px;">
        <button class="roi-popup-close" (click)="closeDemoPopupEvent.emit()">×</button>
        <div class="roi-header">
            <div class="roi-icon">📅</div>
            <h2>Réserver une démo personnalisée</h2>
            <p>Choisissez un créneau qui vous convient</p>
        </div>
        <div style="min-height: 600px; background: white; border-radius: 16px; overflow: hidden;">
            <!-- Calendly embed - Remplacez l'URL par votre vrai lien Calendly -->
            <iframe src="https://calendly.com/your-calendly-link" 
                    width="100%" 
                    height="600" 
                    frameborder="0"
                    style="border-radius: 16px;">
            </iframe>
            <p style="text-align: center; padding: 2rem; color: var(--text-gray);">
                Vous n'avez pas trouvé un créneau qui vous convient ? Contactez-nous directement à  
            </p>
        </div>
    </div>
</div>
